module.exports = __webpack_public_path__ + "img/mercedes-araoz.0bde6b06.png";